var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-footer"}},[_c('p',{attrs:{"id":"cr"}},[_vm._v("Copyright © 2020 - "+_vm._s(_vm.year)+" Tech Elevator Inc.")]),_c('p',{attrs:{"id":"ver"}},[_vm._v(_vm._s(_vm.version))])])}
var staticRenderFns = []

export { render, staticRenderFns }